var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"end-time"},[_vm._v("\n  "+_vm._s(_vm.scope.row.isForever ? '不限' : (_vm.scope.row.isEnd ? '已结束' : _vm.scope.row.endTime.split(' ')[0]))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }